/**
 * Cmarkdownhr Component
 * Horizontal rule component for markdown rendering
 */
'use client';
import type { CSSProperties } from 'react';
import { Cdivider, DividerOrientation } from '../Cdivider';
import { ColorType } from '@/theme/colors';
import { pxToRem } from '@/theme/spacing';
export interface CmarkdownhrProps {
    className?: string;
    style?: CSSProperties;
}
export function Cmarkdownhr({ className, style, }: CmarkdownhrProps) {
    const wrapperStyle: CSSProperties = {
        display: 'flex',
        margin: `${pxToRem(16)} 0`,
        ...style,
    };
    return (
      <div className={className} style={wrapperStyle}>
        <Cdivider orientation={DividerOrientation.Horizontal} color={ColorType.White} opacity={0.2} thickness={1}/>
      </div>
    );
}
